import React from 'react';

import { LoadingSpinner } from './LoadingSpinner';

export interface LoadingStateProps {
  message?: string;
  className?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
  className = "",
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-6 w-full ${className}`}>
      <LoadingSpinner size="lg" />
      <p className="text-gray-500 mt-4">{message}</p>
    </div>
  );
};

export default LoadingState;
